import { RootState } from '@/store/store';
import { AssetActionsBar } from '@/components/pages/AssetsPreviewPage';
import { FaultReasons } from '@/modules';
import React from 'react';
import { useSelector } from 'react-redux';
import { BaseCard } from '../Cards';
import { Counter } from '../Counter';
import { BaseTooltip } from '../Tooltip';
import { ASSET_STUDIO } from '@/types/shared/navigation-tabs.enums';

interface MaintenanceCardProps {
  item: any;
  isSelected: boolean;
  onClick?: () => void;
}
// @TODO: Seperate to smaller components + create a single componet with variant for asset selector and components selector(!!!)
export const MaintenanceCard = ({ item, onClick, isSelected }: MaintenanceCardProps) => {
  const { name, asset_model, asset_supplier } = item;
  const itemName = asset_model && asset_supplier ? `${name} ${asset_supplier} ${asset_model}` : name;

  return (
    <BaseTooltip className="min-w-full max-w-[100px]" content={`${itemName}`}>
      <BaseCard
        onClick={() => !item.disabled && onClick && onClick()}
        key={item.id}
        classNames={{
          card: `rounded-lg hover:ring-1 hover:ring-inset ring-primary-500 hover:cursor-pointer p-1 ${
            isSelected && 'ring-2 ring-inset'
          }  h-[3.4rem] min-h-[3.4rem] max-h-[4.5rem]  flex flex-col justify-center ${
            item.id.includes('all-') && 'h-[3rem] min-h-[3rem] max-h-[3rem] flex items-center'
          }`,
          content: `rounded-md font-medium h-full w-full self-center text-sm flex-col justify-center
          } ${item.id.includes('all-') && 'min-h-[3rem] flex  items-center'}`,
        }}
        dataTestId={item.test_id}
      >
        <div className="flex items-center justify-between w-full gap-1 h-full">
          <div className="w-4/5 flex justify-start text-left h-full items-center">{itemName}</div>
          <div className="w-1/5 text-right flex justify-end items-center ">
            {(item?.id?.includes('all-') || item.counter !== undefined) && !item.hideCounter ? (
              <Counter value={item?.counter} variant={'tab'} size="md" dataTestId="counter" />
            ) : (
              item && <AssetActionsBar asset={item} variant="component-card" onClick={onClick} />
            )}
          </div>
        </div>
      </BaseCard>
    </BaseTooltip>
  );
};
